module.exports = __webpack_public_path__ + "img/h3.e83fc3a4.svg";